<script>
  import ChoiceInput from './choice-input.svelte';

  export let value;

  export let onChange = () => {};

  const options = [
    { value: 'start', icon: 'align-horizontal-justify-start' },
    { value: 'center', icon: 'align-horizontal-justify-center' },
    { value: 'end', icon: 'align-horizontal-justify-end' },
    { value: 'space-between', icon: 'align-horizontal-space-between' }
  ];
</script>

<ChoiceInput {value} {options} {onChange} />
